import './ClockInOut.scss'
import { differenceInMinutes, format, getHours } from 'date-fns'
import { CLOCK_IN_STATUS, displayGreeting, CLOCK_OUT_STATUS } from './ClockinOutConfig'
import Button from '../../../../components/prime-react-overrides/button/Button'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import React, { useEffect, useState } from 'react'
import { useAddDataAttendanceCollectionQuery, useClockInMutation, useClockOutMutation } from '../../../../services/attendance-portal/clockInOut'
import Modal from '../../../../components/prime-react-overrides/modal/Modal'
import { selectIsUserLoggedIn, selectUser, } from '../../../login-page/LoginAuthSlice'
import { useToggle } from '../../../../hooks'

const ClockInOutCard = () => {
    let currentHour = getHours(new Date())
    const currentDay = format(new Date(), 'EEEE')
    const isPersonLoggedIn = useSelector(selectIsUserLoggedIn)
    let { displayImg, greeting } = displayGreeting(currentHour)
    const activeUser = useSelector(selectUser)
    const [showConfirmation, setShowConfirmation] = useToggle(false)
    const [buttonText, setButtonText] = useState(CLOCK_IN_STATUS)
    const [clockInOutButtonLoading, setClockInClockOutButtonLoading] = useState(false)
    const [clockInTimeToDisplay, setClockInTimeToDisplay] = useState(null)
    const [clockOutTimeToDisplay, setClockOutTimeToDisplay] = useState(null)
    const [workingHours, setWorkingHours] = useState(null)
    const [addClockInTime] = useClockInMutation()
    const [addClockOutTime] = useClockOutMutation()
    const [allowClockIn, setAllowClockIn] = useState(true)
    const { data: punchTimeAllData, isLoading } = useAddDataAttendanceCollectionQuery(null, { skip: !isPersonLoggedIn, refetchOnFocus: true, refetchOnMountOrArgChange: true, refetchOnReconnect: true })

    useEffect(() => {
        if (!isLoading && punchTimeAllData) {
            setAllowClockIn(punchTimeAllData.allowClockIn ?? false)
            if ("clockIn" in punchTimeAllData) {
                let _tempClockIn = punchTimeAllData.clockIn
                setClockInTimeToDisplay(format(new Date(_tempClockIn), 'h:mm a'))
                setButtonText(CLOCK_OUT_STATUS)
            }
            if ("clockOut" in punchTimeAllData) {
                let _tempClockOut = punchTimeAllData.clockOut
                setClockOutTimeToDisplay(format(new Date(_tempClockOut), 'h:mm a'))
                setButtonText(CLOCK_IN_STATUS)
            }
        }
    }, [punchTimeAllData, isLoading])

    useEffect(() => {

        let setIntervalTimerId = null;
        if (punchTimeAllData && punchTimeAllData.clockIn) {
            let _tempWorkingMinutes = differenceInMinutes(new Date(), new Date(punchTimeAllData.clockIn))
            let hours = Math.floor(+_tempWorkingMinutes / 60)
            let minutes = +_tempWorkingMinutes % 60
            const toSetWorkingHours = `${hours} hours ${minutes} minutes`
            setWorkingHours(toSetWorkingHours)
            setIntervalTimerId = setInterval(() => {
                let _tempWorkingMinutes = differenceInMinutes(new Date(), new Date(punchTimeAllData.clockIn))
                let hours = Math.floor(+_tempWorkingMinutes / 60)
                let minutes = +_tempWorkingMinutes % 60
                const toSetWorkingHours = `${hours} hours ${minutes} minutes`
                setWorkingHours(toSetWorkingHours)

            }, 60000)
        }
        return () => {
            clearInterval(setIntervalTimerId)
        }
    }, [punchTimeAllData])

    useEffect(() => {
        setClockInClockOutButtonLoading(isLoading)
    }, [isLoading])

    const handleClockInButtonChange = async () => {
        if (allowClockIn) {
            let _tempClockIn = null
            if (buttonText === CLOCK_IN_STATUS) {
                setClockInClockOutButtonLoading(true)
                let allData = await addClockInTime()
                _tempClockIn = allData?.data?.clockIn
                setClockInTimeToDisplay(format(new Date(_tempClockIn), 'h:mm a'))
                setButtonText(CLOCK_OUT_STATUS)
                setAllowClockIn(false)
                setClockInClockOutButtonLoading(false)
            }
        }
        else if (!allowClockIn && buttonText === CLOCK_IN_STATUS) {
            toast.error('You are not allowed to clock in right now, try again after some time, or reload the page', { duration: 7000 })
        }
        else if (!allowClockIn && buttonText === CLOCK_OUT_STATUS) {
            setShowConfirmation()
        }

    }

    const handleClockOutButtonChange = async () => {
        let _tempAllData = await addClockOutTime()
        let _tempClockOut = _tempAllData?.data?.clockOut
        let _tempWorkingHours = _tempAllData?.data?.workingHours
        setClockOutTimeToDisplay(format(new Date(_tempClockOut), 'h:mm a'))

        let hours = Math.floor(_tempWorkingHours / 60)
        let minutes = _tempWorkingHours % 60
        const toSetWorkingHours = `${hours} hours ${minutes} minutes`
        setWorkingHours(toSetWorkingHours)
        setAllowClockIn(false)
        setButtonText(CLOCK_IN_STATUS)
        setShowConfirmation()
    }
    return (
        <div className='ClockInOutCard p-3 h-full'>
            <Modal header='Clock Out' visible={showConfirmation} onHide={setShowConfirmation} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ width: '50vw' }}>
                <h5 className='GrayText text-base text-center mb-5 font-medium'>Are you sure you want to CLOCK OUT?</h5>
                <div className="flex justify-content-evenly align-items-center">
                    <h6 className="text-white text-sm font-normal cursor-pointer" onClick={setShowConfirmation}>
                        Cancel
                    </h6>
                    <Button className='GradientButton text-black text-sm font-semibold w-3' label={CLOCK_OUT_STATUS} onClick={handleClockOutButtonChange} />
                </div>
            </Modal>
            <div className="grid grid-nogutter h-full">
                <div className="col-12">
                    <div className="flex h-full">

                        <div className='flex justify-content-between flex-column w-full'>
                            <div className='flex  align-items-end w-full '>
                                <div className='SvgGreeting '>
                                    {displayImg}
                                </div>
                                <p className='p-2 m-0  font-medium text-white text-base md:text-lg'>
                                    {greeting}
                                </p>
                                <p className='UserName p-0 m-0  text-4xl font-bold'>
                                    {`${activeUser?.firstName ? `${activeUser?.firstName}!` : ""}`}
                                </p>
                            </div>
                            <p className="text-xs GrayText">Let's beat the {currentDay} blues today</p>

                            <div className="grid mx-0 grid-nogutter p-0 justify-content-between align-items-center ">
                                <div className="col-12 md:col grid grid-nogutter m-0 p-0 justify-content-between align-items-center">
                                    <div className="flex flex-column text-white align-items-center text-xs md:text-sm">
                                        <span className=" font-medium">Clock-in</span>
                                        <span className=' font-medium'>{clockInTimeToDisplay === null ? '- - -' : clockInTimeToDisplay}</span>
                                    </div>
                                    <div className="flex flex-column text-white align-items-center text-xs md:text-sm">
                                        <span className="  font-medium">Clock-out</span>
                                        <span className=' font-medium'>{clockOutTimeToDisplay === null ? '- - -' : clockOutTimeToDisplay}</span>

                                    </div>
                                    <div className="flex flex-column align-items-center  text-white text-xs md:text-sm">
                                        <span className="  font-medium">Working Hours</span>
                                        <span className=' font-medium'>{workingHours === null ? '- - -' : workingHours}</span>
                                    </div>
                                </div>
                                <div className="col-12 md:col-4 flex justify-content-end">
                                    <Button className='ClockInOutBtn uppercase md:p-button-lg p-button-sm md:w-8rem w-full mt-2 md:mt-0 white-space-nowrap' label={buttonText} onClick={handleClockInButtonChange} loading={clockInOutButtonLoading} />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ClockInOutCard